import { Input } from '@/components/ui/input'
import { useTranslation } from '@/hooks/use-translation'
import { useNumberRangeFilter } from '../../hooks/use-number-range-filter'
import type { FilterValue, NumberFilterValue } from '../../types/data-table.types'

export interface NumberRangeFilterProps {
  columnId: string
  columnTitle: string
  value: NumberFilterValue | undefined
  onChange: (value: FilterValue) => void
}

export function NumberRangeFilter({
  columnId,
  columnTitle,
  value,
  onChange,
}: NumberRangeFilterProps) {
  const t = useTranslation()
  const { handleMinChange, handleMaxChange, hasValidationError } = useNumberRangeFilter(
    value,
    onChange,
  )

  return (
    <div className="space-y-1">
      <label htmlFor={`filter-min-${columnId}`} className="text-xs font-medium">
        {columnTitle}
      </label>
      <div className="space-y-1">
        <div className="flex space-x-2">
          <div className="flex-1">
            <Input
              id={`filter-min-${columnId}`}
              type="number"
              placeholder={t('dataTable.min')}
              value={value?.min || ''}
              onChange={(e) => handleMinChange(e.target.value)}
              max={value?.max ? Number(value.max) : undefined}
              className="h-7 text-xs"
            />
          </div>
          <div className="flex-1">
            <Input
              id={`filter-max-${columnId}`}
              type="number"
              placeholder={t('dataTable.max')}
              value={value?.max || ''}
              onChange={(e) => handleMaxChange(e.target.value)}
              min={value?.min ? Number(value.min) : undefined}
              className="h-7 text-xs"
            />
          </div>
        </div>
        {hasValidationError && (
          <p className="text-xs text-destructive">{t('dataTable.minGreaterThanMax')}</p>
        )}
      </div>
    </div>
  )
}
